"use client";
import { CloseIcon } from "@chakra-ui/icons";
import { Box, BoxProps, Flex, useBreakpointValue } from "@chakra-ui/react";
import { motion, MotionProps } from "framer-motion";
import { ParsedBanner } from "lib/gcms";
import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { HiTrendingUp } from "react-icons/hi";

const MotionBox = motion<Omit<BoxProps, keyof MotionProps>>(Box);

export const Banner = ({
  message,
  bg,
  color,
  button,
  ...rest
}: ParsedBanner & Omit<BoxProps, keyof ParsedBanner>) => {
  const [isOpen, setIsOpen] = useState(true);
  const isMobile = useBreakpointValue({ base: true, sm: false }) || false;
  const scrollTextGapPercent = 5;
  const linkStyling = {
    a: {
      color,
      fontWeight: "medium",
      textDecoration: "underline",
      _hover: {
        color,
        fontWeight: "medium",
      },
    },
    p: {
      mt: "0",
      color,
    },
  };
  return (
    <Box h="0" position="relative">
      <Box
        w="full"
        position="absolute"
        display={isOpen ? "block" : "none"}
        {...{ bg, color, ...rest }}
        borderBottomWidth="1px"
        borderColor="gray.300"
      >
        <Flex
          maxW="7xl"
          w="100%"
          mx="auto"
          py="10px"
          px={{
            base: "10px",
            sm: "20px",
          }}
          alignItems="center"
          gap={{ base: "10px", sm: "20px" }}
        >
          <MotionBox
            animate={{ rotate: 360 }}
            transition={{
              repeat: Infinity,
              repeatType: "loop",
              repeatDelay: 10,
              duration: 1,
              delay: 2,
              ease: "anticipate",
            }}
            transformOrigin="50% 50%"
          >
            <Box
              as={HiTrendingUp}
              boxSize={{ base: "25px", md: "30px" }}
              color="red.500"
            />
          </MotionBox>
          {isMobile && (
            <Box overflow="hidden">
              <MotionBox
                animate={{ x: `-${50 + scrollTextGapPercent}%` }}
                transition={{
                  repeat: Infinity,
                  repeatType: "loop",
                  repeatDelay: 5,
                  duration: 10,
                  delay: 3,
                  ease: "linear",
                }}
                whiteSpace="nowrap"
                gap={`${scrollTextGapPercent}%`}
                display="flex"
                sx={linkStyling}
                w="fit-content"
                pl="1px"
              >
                {message}
              </MotionBox>
            </Box>
          )}
          {!isMobile && <Box sx={linkStyling}>{message}</Box>}
          {/** The "x" button on the far right */}
          <CloseIcon
            // Justify right
            ml="auto"
            as={FaTimes}
            boxSize={{ base: "20px", md: "20px" }}
            onClick={() => setIsOpen(false)}
            cursor="pointer"
          />
        </Flex>
      </Box>
    </Box>
  );
};

export default Banner;
